import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isKeyExistInPropertyFile, isIntentCodeExists } from '../../lib/omnichannelHelper';
import { trackPage } from '../../lib/analytics-helper';
import OmniChannelPromptComponent from '../../common/OmniChannelPromptComponent';
import i18n from '../../lib/reacti18n';
import { updateContextPromptConfirmation, updateContextPromptRejection } from '../../contactUs/actions/action-article';
import { OMNI_CHANNEL_ARTICLE } from '../constants/PropTypesShapes';
import { doServerSideFptiCall } from '../../common/ocpCardPrompt/action-ocpComponent';

const labels = {
  omniChannelConfirm: i18n.message('smarthelp/omniChannel.omniChannelPrompt.yes'),
  omniChannelReject: i18n.message('smarthelp/omniChannel.omniChannelPrompt.no'),
};

class OmniChannelPromptContainer extends Component {
  /**
   * Function for rejecting the omni channel intent on hcr home page
   */
  omniChannelApproveIntent(articleInfo, intentCode) {
    this.props.updateContextPromptConfirmation(articleInfo, intentCode);
  }

  /**
   * Function for rejecting the omni channel intent on hcr home page
   */
  omniChannelRejectIntent(articleInfo, intentCode) {
    this.props.updateContextPromptRejection(articleInfo, intentCode);
  }

  renderOmniChannelPrompt() {
    const { isOmniChannelPromptEnabled, omniChannelIntentArticles } = this.props;
    // if user is part of update context elmo, IntentCode in the Article exist and translations available then  open the prompt
    if (isOmniChannelPromptEnabled && isIntentCodeExists(omniChannelIntentArticles)) {
      const intentCode = omniChannelIntentArticles.intentArticleDetails[0].contextMetaData.intent.intent_code;
      // checking if the translations are available for intent code
      const intentLabelExists = isKeyExistInPropertyFile('smarthelp/omniChannel', intentCode);

      // If translations exists show the prompt
      if (intentLabelExists) {
        // Firing FPTI if omnichannel prompt is displayed
        trackPage({ id: 'omniChannelPromptDisplayed', link: `smarthelp-omnichannel-prompt-displayed|${intentCode}`, ocp_context_metadata: intentCode });
        doServerSideFptiCall(omniChannelIntentArticles.intentArticleDetails[0]);

        return (
          <OmniChannelPromptComponent
            promptSize="lg"
            intentDescription={i18n.message(`smarthelp/omniChannel.${intentCode}`)}
            confirmLabel={labels.omniChannelConfirm}
            rejectLabel={labels.omniChannelReject}
            omniChannelRejectIntentCBFunc={() => this.omniChannelRejectIntent(omniChannelIntentArticles.intentArticleDetails[0], intentCode)}
            omniChannelApproveIntentCBFunc={() => this.omniChannelApproveIntent(omniChannelIntentArticles.intentArticleDetails[0], intentCode)}
          />
        );
      }

      // Firing FPTI if omnichannel prompt is not displayed
      trackPage({ id: 'omniChannelPromptNotDisplayed', link: `smarthelp-omnichannel-prompt-failed-for-no-translations|${intentCode}`, ocp_context_metadata: intentCode });
    }

    return <div />;
  }

  render() {
    if (this.props.hideOmniChannelPrompt) {
      return <div />;
    }

    return this.renderOmniChannelPrompt();
  }
}

OmniChannelPromptContainer.propTypes = {
  isOmniChannelPromptEnabled: PropTypes.bool,
  updateContextPromptRejection: PropTypes.func.isRequired,
  updateContextPromptConfirmation: PropTypes.func.isRequired,
  omniChannelIntentArticles: PropTypes.shape(OMNI_CHANNEL_ARTICLE),
  hideOmniChannelPrompt: PropTypes.bool.isRequired,
};

OmniChannelPromptContainer.defaultProps = {
  isOmniChannelPromptEnabled: false,
  omniChannelIntentArticles: {},
};

function mapStateToProps(state) {
  return {
    isOmniChannelPromptEnabled: state.popular.isOmniChannelPromptEnabled,
    omniChannelIntentArticles: state.popular.omniChannelIntentArticles,
    isLoading: state.popular.isLoading,
    hideOmniChannelPrompt: state.popular.hideOmniChannelPrompt,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateContextPromptConfirmation, updateContextPromptRejection }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OmniChannelPromptContainer);
